<sbnb-signup-wizard-template>
  <ng-container left-side>
    <sbnb-signup-user-header *ngIf="isFirstStep" class="mb-8"></sbnb-signup-user-header>
    <h1 *ngIf="!isFirstStep" class="text-2xl md:text-3xl mb-8">How many properties do you manage?</h1>

    <p class="mb-6">To personalize your onboarding experience, please let us know how many properties you manage.</p>

    <form [formGroup]="form">
      <label class="text-sm font-bold block text-night" for="propertiesCount">Number of properties</label>
      <mat-form-field class="w-full">
        <input matInput type="text" name="propertiesCount" formControlName="propertiesCount" />
        <mat-error *ngIf="form.controls.propertiesCount?.errors?.required">
          Number of properties {{ 'CORE.IS_REQUIRED' | transloco }}
        </mat-error>
      </mat-form-field>

      <sbnb-button
        class="block mt-8"
        [fullWidth]="true"
        [disabled]="form.invalid"
        [loading]="loading"
        (clicked)="onContinue()">
        Continue
      </sbnb-button>
    </form>
  </ng-container>

  <sbnb-signup-quick-facts right-side *ngIf="isFirstStep"></sbnb-signup-quick-facts>
  <ng-container right-side *ngIf="!isFirstStep">
    <img
      data-signup-portfolio-image
      *ngIf="form.controls.propertiesCount?.value > 9; else smallPortfolio"
      src="/assets/images/signup/properties-large.svg" />

    <ng-template #smallPortfolio>
      <img data-signup-small-portfolio-image src="/assets/images/signup/properties-small.svg" />
    </ng-template>
  </ng-container>
</sbnb-signup-wizard-template>
